import $$ from 'cmn-utils'
import tokit from "../http/tokiot"

/**
 * 获取用户信息
 */
export async function getUserInfo(params) {
    return tokit.sys.user.getDetail(params)
    return $$.get('/api/sys/user/get-detail', params)
}